export const Main = {
  paddingTop: 3,
};
